import React, { useState, useEffect } from 'react';
import CustomToasts from '../../common/components/CustomeToasts/CustomToasts';
import _ from 'lodash';
import { getSourceList } from '../../common/constants/api';

const SelectedFilters = ({ filteredData, onCloseHandler }) => {
  const [sourceList, setSourceList] = useState([]);

  useEffect(() => {
    getSourceList().then(res => {
      setSourceList(res);
    });
  }, []);

  let filterClass =
    'font-roboto  font-medium mt-2 mr-2 text-purple-1000  items-center';
  let commonStyle = { width: '60px' };

  const handleCloseEvent = (name, filterName) => {
    onCloseHandler(name, filterName);
  };
  return (
    <div className="w-full">
      <div className="w-full">
        <div className="w-full flex flex-wrap">
          {_.some(Object?.values(filteredData?.Product || {})) && (
            <span className={filterClass} style={commonStyle}>
              Product
            </span>
          )}
          {Object?.keys(filteredData?.Product || {})?.map(
            each =>
              filteredData?.Product[each] && (
                <CustomToasts
                  textMessage={each}
                  referName={each}
                  componentStyle={{ minWidth: '50px' }}
                  OnCloseHandler={e => {
                    handleCloseEvent('Product', e);
                  }}
                />
              )
          )}
        </div>
        <div className="w-full flex flex-wrap">
          {_.some(Object?.values(filteredData?.Status || {})) && (
            <span className={filterClass} style={commonStyle}>
              Status
            </span>
          )}

          {Object?.keys(filteredData?.Status || {})?.map(
            each =>
              filteredData?.Status[each] && (
                <CustomToasts
                  textMessage={each}
                  referName={each}
                  componentStyle={{ minWidth: '50px' }}
                  OnCloseHandler={e => {
                    handleCloseEvent('Status', e);
                  }}
                />
              )
          )}
        </div>
        <div className="w-full flex flex-wrap">
          {_.some(Object?.values(filteredData?.Source || {})) && (
            <span className={filterClass} style={commonStyle}>
              Source
            </span>
          )}

          {Object?.keys(filteredData?.Source || {})?.map(
            each =>
              filteredData?.Source[each] && (
                <CustomToasts
                  textMessage={_.get(
                    sourceList?.filter(every => every?.id == each),
                    '[0].displayName'
                  )}
                  referName={each}
                  componentStyle={{ minWidth: '50px' }}
                  OnCloseHandler={e => {
                    handleCloseEvent('Source', parseInt(e));
                  }}
                />
              )
          )}
        </div>
      </div>
    </div>
  );
};

export default SelectedFilters;
